module.exports = __webpack_public_path__ + "img/call-end.df388ced.svg";